import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import { withStyles } from 'theme/withStyles';
import BottomContent from 'common/BottomContent';
import ErrorMsg from 'common/ErrorMsg';

import commonStyles from './styles';

const styles = (theme) => commonStyles(theme);

const AutoExportBare = ({
  bottomContent,
  classes,
  hasFields,
  label,
  labelMobile,
  name,
  subText,
}) => (
  <>
    <legend
      className={classnames('grp-label', classes.label)}
      role={!hasFields ? 'presentation' : undefined}
    >
      <RawHtml type="span" className={classnames('desktop', classes.desktopLabel)}>
        {label}
      </RawHtml>
      <RawHtml type="span" className={classnames('mobile', classes.mobileLabel)}>
        {labelMobile}
      </RawHtml>
    </legend>

    <RawHtml className={classnames('content', classes.content)}>{subText}</RawHtml>

    <ErrorMsg name={name} type="group" />

    <BottomContent className="bottomContent">{bottomContent}</BottomContent>
  </>
);

AutoExportBare.propTypes = {
  bottomContent: PropTypes.string,
  hasFields: PropTypes.bool,
  label: PropTypes.string,
  labelMobile: PropTypes.string,
  name: PropTypes.string.isRequired,
  subText: PropTypes.string,
};

AutoExportBare.defaultProps = {
  bottomContent: '',
  hasFields: false,
  label: '',
  labelMobile: '',
  subText: '',
};

const AutoExportStyled = withStyles(styles)(AutoExportBare);

const mapStateToProps = ({ groups }, { name }) => {
  const group = groups[name];
  return {
    bottomContent: group.bottomContent,
    hasFields: group?.fields?.length > 0 ?? false,
    label: group.label,
    labelMobile: group.labelMobile,
    subText: group.subText,
  };
};

export default connect(mapStateToProps)(AutoExportStyled);
